import { twMerge } from "tailwind-merge";
import { PropsWithAs } from "../types";
import { ForwardedRef } from "react";
import { forwardRefWithGeneric } from "../utils";

export interface CardSubTitleProps {}

const CardSubTitle = <T extends React.ElementType = "div">(
  { as, ...props }: PropsWithAs<CardSubTitleProps, T>,
  ref: ForwardedRef<any>
) => {
  const { className, ...rest } = props;
  const Component = as ?? "div";
  return (
    <Component
      {...rest}
      ref={ref}
      className={twMerge("font-light text-slate-600", className)}
    />
  );
};

export default forwardRefWithGeneric(CardSubTitle);
